export default __webpack_public_path__ + "static/media/LandingPageVideo.fd06e935.mp4";